/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationAppIcon16Regular = forwardRef('NotificationAppIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.75 0a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM11 3.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z" }),
        React.createElement("path", { d: "M2.75 4.5c0-.966.784-1.75 1.75-1.75h3.25a.75.75 0 0 0 0-1.5H4.5A3.25 3.25 0 0 0 1.25 4.5v7a3.25 3.25 0 0 0 3.25 3.25h7a3.25 3.25 0 0 0 3.25-3.25V8.25a.75.75 0 0 0-1.5 0v3.25a1.75 1.75 0 0 1-1.75 1.75h-7a1.75 1.75 0 0 1-1.75-1.75v-7Z" })));
});
